import BasePopoverDropdown from './BasePopoverDropdown';


export default (Vue) => {
  Vue.component(BasePopoverDropdown.name, BasePopoverDropdown);
};



// WEBPACK FOOTER //
// ./src/components/common/base-popover-dropdown/index.js